import classnames from 'classnames';
import React, { useRef } from 'react';
import styles from './styles.module.less';

const ScaleAction = () => {
    const backSlashCursorNodeRef = useRef<HTMLSpanElement>(null);
    const slashCursorNodeRef = useRef<HTMLSpanElement>(null);
    const backSlashCursorArr = [3, 0, 1, 2];
    const slashCursorArr = [1, 2, 3, 0];

    return (
        <div className="l-cropStage-scaleAction">
            <span ref={backSlashCursorNodeRef}>
                <div
                    className={classnames('vertex lt', {
                        [styles[`scale-${backSlashCursorArr[0]}`]]: true,
                    })}
                    data-type="crop-lt"
                />
                <div
                    className={classnames('vertex rb', {
                        [styles[`scale-${backSlashCursorArr[0]}`]]: true,
                    })}
                    data-type="crop-rb"
                />
            </span>

            <span ref={slashCursorNodeRef}>
                <div
                    className={classnames('vertex lb', {
                        [styles[`scale-${slashCursorArr[0]}`]]: true,
                    })}
                    data-type="crop-lb"
                />
                <div
                    className={classnames('vertex rt', {
                        [styles[`scale-${slashCursorArr[0]}`]]: true,
                    })}
                    data-type="crop-rt"
                />
            </span>
        </div>
    );
};

export default ScaleAction;
